export enum BackgroundOperationType {
  AddressPointResolution = 'addressPointResolution',
  Print = 'print',
  Upload = 'upload',
}
